import React, { useState } from 'react';
import './TabsComponent.scss';
export var TabsComponent = function (_a) {
    var titles = _a.titles, children = _a.children, secondary = _a.secondary, badgeText = _a.badgeText;
    var _b = useState(0), activeTab = _b[0], setActiveTab = _b[1];
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sdds-inline-tabs ".concat(secondary ? "sdds-inline-tabs-secondary" : ""), key: "tab-container" },
            React.createElement("nav", { className: "sdds-inline-tabs-header", key: "tab-header" },
                React.createElement("div", { className: "sdds-inline-tabs-wrapper", key: "tab-wrapper" }, titles.map(function (tabTitle, index) {
                    return React.createElement(React.Fragment, null,
                        React.createElement("button", { key: tabTitle, className: "sdds-inline-tabs--tab ".concat(index === activeTab ? "sdds-inline-tabs--tab__active" : " "), onClick: function () { setActiveTab(index); } },
                            React.createElement("span", { key: "".concat(tabTitle, "-text") }, tabTitle),
                            badgeText && React.createElement("div", { className: "tab-badges", key: "".concat(tabTitle, "-badge") },
                                React.createElement("div", { className: "sdds-badges sdds-badges-default" },
                                    React.createElement("div", { className: "sdds-badges-text" }, badgeText)))));
                }))),
            React.createElement("div", { className: "sdds-inline-tabs-main" }, children && children.map(function (child, index) {
                return React.createElement(React.Fragment, null, index === activeTab && child);
            }))));
};
export default TabsComponent;
